import React from "react";
import { Helmet } from "react-helmet";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import WebHero from "../Components/website/WebHero";
import WhyChooseWeb from "../Components/website/WhyChooseWeb";
import WebProcess from "../Components/website/WebProcess";
import WebServices from "../Components/website/WebServices";
import websiteFaqs from "../Components/website/websiteFaqs";
import TrustedIndustries from "../Components/home/TrustedIndustries";
import Ratings from "../Components/home/Ratings";
import Testimonials from "../Components/home/Testimonials";
import FaqContact from "../Components/home/FaqContact";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: websiteFaqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

// Redesigned (Tailwind) page for /service/website-design-development-solutions.
const WebsiteDesignPage = () => (
  <div>
    <SEOPage
      title="Website Design & Development Company in Noida | DataMetricks"
      description="DataMetricks designs and develops modern, responsive, SEO-friendly websites, e-commerce stores, CMS sites and web applications that help businesses grow online."
      canonicalUrl="https://www.datametricks.com/service/website-design-development-solutions"
    />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>

    <Navbar />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <WebHero />
      <WhyChooseWeb />
      <WebProcess />
      <WebServices />
      <TrustedIndustries />
      <Ratings />
      <Testimonials />
      <FaqContact faqs={websiteFaqs} />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default WebsiteDesignPage;
